import { SITE, FAQS } from "@/data/site";

const ogImage = `${SITE.domain}/images/hero-hidangan.jpg`;

const restaurantLd = {
  "@context": "https://schema.org",
  "@type": "Restaurant",
  name: SITE.name,
  alternateName: SITE.longName,
  url: `${SITE.domain}/`,
  image: ogImage,
  servesCuisine: ["Masakan Minang", "Masakan Padang", "Indonesia"],
  telephone: "+62-818-0205-5888",
  founder: { "@type": "Person", name: "Arief Muhammad" },
  foundingDate: "2022-07-24",
  parentOrganization: { "@type": "Organization", name: SITE.company },
  address: {
    "@type": "PostalAddress",
    streetAddress: "Jl. Islamic 2 No.3, Kelapa Dua, Karawaci",
    addressLocality: "Kabupaten Tangerang",
    addressRegion: "Banten",
    postalCode: "15810",
    addressCountry: "ID",
  },
  sameAs: [SITE.instagram, SITE.facebook, SITE.linkedin, SITE.official],
};

const websiteLd = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: SITE.longName,
  url: `${SITE.domain}/`,
  inLanguage: "id-ID",
};

const crumb = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map(([name, path], i) => ({
    "@type": "ListItem",
    position: i + 1,
    name,
    item: `${SITE.domain}${path}`,
  })),
});

const faqLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: FAQS.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

export const routesMeta = [
  {
    path: "/",
    title: "RM. Payakumbuah | Nasi Padang Otentik Khas Minangkabau",
    description:
      "RM. Payakumbuah menyajikan masakan Minang otentik — rendang, dendeng batokok lado merah, ayam pop — dengan beras Solok pilihan. Lihat menu, outlet, dan cara pesan.",
    jsonLd: [restaurantLd, websiteLd],
  },
  {
    path: "/menu/",
    title: "Menu | RM. Payakumbuah — Rendang, Dendeng Batokok, Ayam Pop",
    description:
      "Jelajahi menu masakan Minang RM. Payakumbuah: rendang, dendeng batokok lado merah, ayam pop, teh talua, es durian, hingga nasi box untuk acara.",
    jsonLd: [crumb([["Beranda", "/"], ["Menu", "/menu/"]])],
  },
  {
    path: "/tentang/",
    title: "Tentang Kami | RM. Payakumbuah",
    description:
      "Cerita RM. Payakumbuah — rumah makan masakan Minang yang digagas Arief Muhammad, diresmikan Wakil Gubernur Sumatera Barat, dan memakai beras Solok pilihan.",
    jsonLd: [crumb([["Beranda", "/"], ["Tentang Kami", "/tentang/"]])],
  },
  {
    path: "/lokasi/",
    title: "Lokasi & Outlet | RM. Payakumbuah",
    description:
      "Temukan outlet RM. Payakumbuah di Jakarta, Tangerang, Depok, Bogor, Bekasi, Bandung, dan Semarang, beserta tautan peta resmi seluruh outlet.",
    jsonLd: [crumb([["Beranda", "/"], ["Lokasi", "/lokasi/"]])],
  },
  {
    path: "/kontak/",
    title: "Kontak | RM. Payakumbuah",
    description:
      "Hubungi RM. Payakumbuah melalui WhatsApp resmi untuk kritik, saran, kemitraan, dan pemesanan nasi box, atau kunjungi media sosial kami.",
    jsonLd: [crumb([["Beranda", "/"], ["Kontak", "/kontak/"]])],
  },
  {
    path: "/faq/",
    title: "Pertanyaan Umum (FAQ) | RM. Payakumbuah",
    description:
      "Jawaban atas pertanyaan umum seputar RM. Payakumbuah: lokasi outlet, pesan antar GoFood, nasi box & catering, harga menu, dan jam operasional.",
    jsonLd: [faqLd, crumb([["Beranda", "/"], ["FAQ", "/faq/"]])],
  },
];

export const notFoundMeta = {
  title: "Halaman Tidak Ditemukan | RM. Payakumbuah",
  description: "Halaman yang Anda cari tidak tersedia di situs RM. Payakumbuah.",
};

export { ogImage };
